import "./App.scss";
import React from "react";
import LogoutButton from "./components/LogoutButton";
import { UserInfo } from "./types";
import CurrentUser from "./components/currentUser";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";

interface SettingsProps {
  userInfo?: UserInfo | null;
  handleShowHome: () => void;
}

const Settings: React.FC<SettingsProps> = ({ userInfo, handleShowHome }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const [isFOH] = useState(queryParameters.get("foh") ? true : false);

  const handleSwitch = () => {
    let url = new URL(window.location.href);

    if (isFOH) {
      url.searchParams.delete("foh");
    } else {
      url.searchParams.set("foh", "1");
    }

    window.location.href = url.toString();
  };

  return (
    <div className="App settings-wrap">
      <header className="App-header">
        <div className="hlpr-relative hlpr-text-align-left">
          <FontAwesomeIcon
            icon={faXmark as IconProp}
            className="close-window"
            onClick={handleShowHome}
          />
          <CurrentUser userInfo={userInfo} />
          <p>
            If this is not the bakery you are in please raise this with support,
            logout and log back in with the correct details.
          </p>
          <LogoutButton />
          <button
            className="switch-button button--secondary"
            onClick={handleSwitch}
          >
            {isFOH ? "Switch to back of house" : "Switch to front of house"}
          </button>
        </div>
      </header>
    </div>
  );
};

export default Settings;
